import React from "react";
import { DeleteWithConfirmButton, Toolbar, SaveButton, useRedirect, useNotify } from "react-admin";

// Style
import "./EditToolbar.css";

type EditToolbarProps = {
  name: string;
  resource: string;
};

const EditToolbar: React.FC<EditToolbarProps> = ({ name, resource }) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const confirmContentText = `You will not be able to recover this ${name}. Are you sure?`;

  const capitalizeFirstLetter = (str: string): string => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const onSuccess = () => {
    notify(`${capitalizeFirstLetter(name)} deleted`, { type: "success" });
    redirect("list", resource);
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  return (
    <Toolbar className="c-edit-toolbar">
      <SaveButton />
      <DeleteWithConfirmButton
        confirmContent={confirmContentText}
        confirmColor="warning"
        translateOptions={{ name }}
        mutationOptions={{ onSuccess, onError }}
      />
    </Toolbar>
  );
};

export default EditToolbar;
